<div>
    <button
            matIconButton
            class="mat-icon-toggle-button"
            id="collection-manager-toolbar-button"
            [class.selected]="displayPanel"
            type="button"
            matTooltip="{{ !displayPanel ? 'Developer Tool' : null }}"
            (click)="togglePanelDisplay()"
            matTooltipPosition="right">
        <mat-icon>bug_report</mat-icon>
    </button>

    <div class="toolbar-panel-container" [hidden]="!displayPanel">
        <div class="sidebar-component layer-manager-container">
            <div class="row my-1">
                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showViewPanel" matTooltip="Show basic info about view"
                                  (change)="changeViewPanelStatus($event)">
                    View panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showDebugPanel" matTooltip="Show core map debug panel"
                                  (change)="changeDebugPanelStatus($event)">
                    Debug panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showAois" matTooltip="Show aois data" (change)="changeShowAois($event)">
                    Aois Panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showGridControl" matTooltip="Show grid "
                                  (change)="changeGridControlStatus($event)">Grid
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showFootprintsPanel" matTooltip="Show footprints for findimages in point"
                                  (change)="changeFootprintControlStatus($event)">
                    Footprint panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showImagesPanel"
                                  matTooltip="Show table with discrete images for this point"
                                  (change)="changeImagesControlStatus($event)">
                    Images panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1"
                        [checked]="enableImageDiscreteInfo"
                        [disabled]="!this.mapStatus._is3dMode"
                        matTooltip="Show metadata for active discrete image"
                        (change)="changeEnableImageInfo($event)">
                    Discrete Metadata
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showDSMToolsInfo" matTooltip="Show dsm tools"
                                  (change)="changeShowDSMTools($event)">DSM Tools
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showLocationPanel" matTooltip="Change map location"
                                  (change)="changeLocationPanelStatus($event)">
                    Location panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showPaintPanel" matTooltip="Show paint panel"
                                  (change)="changePaintPanelStatus($event)">Paint panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showGeoTiffPanel" matTooltip="Load a local GeoTIFF file as a map layer"
                                  (change)="changeGeoTiffPanelStatus($event)">GeoTIFF panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showStatePanel" matTooltip="Show state panel"
                                  (change)="changeStatePanel($event)">Show state panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showLayerControl" matTooltip="Show native layer controllerl"
                                  (change)="changeLayerControlStatus($event)">
                    Layer panel
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1"
                        [checked]="reprojecInObliques"
                        matTooltip="Enable reproject vector data between obliques"
                        (change)="changeReprojectInObliques($event)">
                    Enable reproject
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1"
                        [checked]="showPolygonTriangulation"
                        matTooltip="Show triangulation used for 3D polygon calculation"
                        (change)="changeShowPolygonTriangulation($event)">
                    Polygon triangulation
                </mat-slide-toggle>

                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="lockDiscrete" [disabled]="!this.mapStatus._is3dMode"
                                  matTooltip="Lock discrete" (change)="lockDiscreteView($event)">
                    Lock discrete view
                </mat-slide-toggle>
            </div>
            <div class="row">
                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="enableMask" matTooltip="Enable Mask" (change)="changeEnableMask($event)">
                    Enable Mask
                </mat-slide-toggle>
                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="checkBorders" matTooltip="Check borders"
                                  (change)="changeCheckBorders($event)">Check Borders
                </mat-slide-toggle>
                <mat-slide-toggle hideIcon="true" class="my-1" [checked]="checkCoverage" matTooltip="Check coverage "
                                  (change)="changeCheckCoverage($event)">Check Coverage
                </mat-slide-toggle>
                <mat-form-field appearance="fill" class="mt-2">
                    <mat-label>Embeddings Implementation</mat-label>
                    <input matInput [value]="embeddingsImplementation" (change)="onChangeEmbeddingsImplementation($event)" />
                </mat-form-field>
            </div>
        </div>
    </div>
</div>

<div class="developer-tools-panel" [hidden]="!enabled">
    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showMapStatus() && showViewPanel" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>Map status</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="row">
                <div class="form-container p-2" *ngIf="showMapStatus()">
                    <p>Projection: {{ coreMap.olMap.getView().getProjection().getCode() }}</p>
                    <p>Mercator Zoom :{{ coreMap.getZoom() }}</p>
                    <p>View Zoom :{{ coreMap.olMap.getView().getZoom() }}</p>
                    <p>Collection Mode :{{ viewerService.collectionMode.name }}</p>
                    <p>
                        Center: {{ centerWkt }}
                        <app-copy-clipboard
                                class="copy-clipboard-button"
                                [message]="'Copied to clipboard'"
                                [tooltipPosition]="'below'"
                                [value]="centerWkt"></app-copy-clipboard>
                    </p>
                    <p>
                        Extent: {{ extentWkt }}
                        <app-copy-clipboard
                                class="copy-clipboard-button"
                                [message]="'Copied to clipboard'"
                                [tooltipPosition]="'below'"
                                [value]="extentWkt"></app-copy-clipboard>
                    </p>
                    <p *ngIf="coreMap.olMap.getView().get('azimut')">View
                        Azimut: {{ coreMap.olMap.getView().get("azimut") }}</p>
                    <p *ngIf="coreMap.olMap.getView().get('orientation')">View
                        Orientation: {{ coreMap.olMap.getView().get("orientation") }}</p>
                    <p>
                        Meters per unit (gsd) size: {{ coreMap.olMap.getView().getProjection().getMetersPerUnit() }}
                        meters per
                        {{ coreMap.olMap.getView().getProjection().getUnits() }}
                    </p>
                    <p>Pixel
                        size: {{ coreMap.olMap.getView().getResolution() * coreMap.olMap.getView().getProjection().getMetersPerUnit() }}
                        meters</p>
                    <p>Resolution
                        size: {{ coreMap.olMap.getView().getResolution() }} {{ coreMap.olMap.getView().getProjection().getUnits() }}
                        / pixel</p>
                    <p>Min/Max Zoom: {{ coreMap.olMap.getView().getMinZoom() }}
                        /{{ coreMap.olMap.getView().getMaxZoom() }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showLocationPanel" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>Location</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="form-container">
                <form [formGroup]="centerForm" (submit)="centerOnCoordinates()">
                    <mat-form-field>
                        <mat-label>-90 30</mat-label>
                        <input matInput name="coordinates" formControlName="coordinates"/>
                    </mat-form-field>

                    <button matButton="elevated" color="primary" type="submit" [disabled]="!centerForm.valid">Find
                    </button>
                </form>
            </div>
            <div class="form-container">
                <form [formGroup]="tileForm" (submit)="findTile()">
                    <mat-form-field>
                        <mat-label>Z/X/Y</mat-label>
                        <input matInput name="tile" formControlName="tile"/>
                    </mat-form-field>

                    <button matButton="elevated" color="primary" type="submit" [disabled]="!tileForm.valid">Find
                    </button>
                </form>
            </div>
            <div class="form-container">
                <form [formGroup]="zoomForm" (submit)="changeZoom()">
                    <mat-form-field>
                        <mat-label>Zoom level</mat-label>
                        <input matInput name="zoom" formControlName="zoom"/>
                    </mat-form-field>

                    <button matButton="elevated" color="primary" type="submit" [disabled]="!zoomForm.valid">Change
                    </button>
                </form>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showFootprintsPanel" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>Footprints</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="row">
                <div class="form-container p-2">
                    <mat-slide-toggle hideIcon="true" class="my-1" [checked]="paintFootprints" (change)="changeShowFootprints($event)">Show
                        footprints
                    </mat-slide-toggle>
                </div>
                <div class="form-container p-2">
                    <mat-button-toggle-group [disabled]="!paintFootprints" name="fontStyle"
                                             [(ngModel)]="footprintsOrientation"
                                             (change)="changeFootprintsOrientation()">
                        <mat-button-toggle value="">All</mat-button-toggle>
                        <mat-button-toggle value="V">V</mat-button-toggle>
                        <mat-button-toggle value="NN,NS,NE,NW">Nadir</mat-button-toggle>
                        <mat-button-toggle value="I">NIR</mat-button-toggle>
                        <mat-button-toggle value="N">N</mat-button-toggle>
                        <mat-button-toggle value="S">S</mat-button-toggle>
                        <mat-button-toggle value="W">W</mat-button-toggle>
                        <mat-button-toggle value="E">E</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!--    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showCoveragePanel" cdkDrag>-->
    <!--        <app-dev-coverage-panel [enabledAOIs]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"></app-dev-coverage-panel>-->
    <!--    </mat-card>-->

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showPaintPanel" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>Paint</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content class="">
            <div class="m-2 p-1 form-container border border-light rounded">
                <form [formGroup]="wktForm" (submit)="wktToDrawLayer()">
                    <mat-form-field>
                        <mat-label>WKT</mat-label>
                        <textarea matInput name="wkt" formControlName="wkt"
                                  placeholder="POLYGON(-90 30 ...)"></textarea>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>EPSG CODE</mat-label>
                        <input matInput name="epsg" formControlName="epsg" placeholder="epsg:4326"/>
                    </mat-form-field>

                    <button matButton="elevated" color="primary" type="submit" [disabled]="!wktForm.valid">Paint WKT
                    </button>
                </form>
            </div>

            <div class="m-2 p-1 form-container border border-light rounded">
                <form [formGroup]="geojsonForm" (submit)="geojsonToDrawLayer()">
                    <mat-form-field>
                        <mat-label>GeoJSON</mat-label>
                        <textarea matInput name="geojson" formControlName="geojson"></textarea>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>EPSG CODE</mat-label>
                        <input matInput name="epsg" formControlName="epsg" placeholder="epsg:4326"/>
                    </mat-form-field>
                    <button matButton="elevated" color="primary" type="submit">Paint</button>
                </form>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showGeoTiffPanel" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>GeoTIFF</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="m-2 p-1 form-container border border-light rounded d-flex align-items-center gap-2">
                <button matButton="elevated" color="primary" type="button" (click)="geotiffFileInput.click()">Choose file</button>
                <input #geotiffFileInput type="file" accept=".tif,.tiff" hidden (change)="onGeoTiffFileSelected($event)"/>
                <span *ngIf="selectedGeoTiffFileName">{{ selectedGeoTiffFileName }}</span>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showStatePanel" cdkDrag>
        <mat-card-header>
            <mat-card-title>Decoded State Parameters</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="state-cols scroll-hidden">
                @for (state of states; track i; let i = $index) {
                    @if (state) {
                        <div class="state-col" [ngClass]="states.length > 1 ? 'col-6' : 'col-12'">
                            <h5>State {{ i }}</h5>
                            <h6>
                                Plain:
                                <button mat-icon-button (click)="toggleStatePlain(i)">
                                    <mat-icon>{{ showStatePlain[i] ? 'remove' : 'add' }}</mat-icon>
                                </button>
                            </h6>

                            @if (showStatePlain[i]) {
                                <pre class="code-block"><code>{{ state.plain }}</code></pre>
                            }

                            <pre class="mb-0">{{ state.decoded | json }}</pre>
                        </div>
                    }
                }
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z4 developer-panel" *ngIf="showDSMToolsInfo" cdkDrag>
        <mat-card-header class="header w-100">
            <mat-card-title>DSM Tools</mat-card-title>
            <div class="floatable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
            </div>
        </mat-card-header>
        <mat-card-content class="">
            <div class="m-2 p-1 form-container border border-light rounded">
                <div class="d-flex align-items-center mb-3">
                    <mat-label class="me-2">DSM tile zoom</mat-label>
                    <input
                            matInput
                            name="tileZoom"
                            (change)="changeDSMTileZoom(dsmTileZoom)"
                            [(ngModel)]="dsmTileZoom"
                            placeholder="DSM download tile size"
                            style="max-width: 120px"/>
                </div>

                <div class="d-flex flex-column mb-3">
                    <h6>DSM Cached information</h6>
                    <div *ngIf="dsmInfo" class="mb-2">
                        <div *ngFor="let key of Object.keys(dsmInfo)">
                            <strong>{{ key }}:</strong>
                            {{ dsmInfo[key] }}
                        </div>
                    </div>
                    <button matButton (click)="getDSMCachedInfo()">Refresh</button>
                </div>

                <div class="d-flex flex-column gap-2 mb-3">
                    <mat-slide-toggle hideIcon="true" class="my-1"
                            [checked]="downloadImageCoverage"
                            matTooltip="Download DSM for image instead of view extent"
                            (change)="changeDSMDownloadCoverage($event)">
                        Download DSM for image
                    </mat-slide-toggle>

                    <mat-slide-toggle hideIcon="true" class="my-1" [checked]="showDSMStatusPanel" matTooltip="Show DSM tiles download"
                                      (change)="showDSMTilesStatus($event)">
                        Show DSM tile status
                    </mat-slide-toggle>

                    <mat-slide-toggle hideIcon="true" class="my-1" [checked]="lockDSMDownloadStatus" matTooltip="Lock DSM download"
                                      (change)="lockDSMDownload($event)">
                        Lock DSM download
                    </mat-slide-toggle>

                    <mat-slide-toggle hideIcon="true" class="my-1" [checked]="DSMCoverage" matTooltip="Show DSM coverage"
                                      (change)="showDSMCoverage($event)">Show DSM coverage
                    </mat-slide-toggle>

                    <button matButton (click)="cleanDSMTilesCache()">Clean tiles cached</button>
                </div>

                <div class="tile-legend border rounded p-2 bg-light"
                     style="display: flex; gap: 16px; align-items: center; margin-bottom: 8px">
          <span style="display: flex; align-items: center">
            <span style="width: 16px; height: 16px; background: #2196f3; border-radius: 3px; display: inline-block; margin-right: 4px"></span>
            <span>Enqued</span>
          </span>
                    <span style="display: flex; align-items: center">
            <span
                    style="
                width: 16px;
                height: 16px;
                background: #ffeb3b;
                border-radius: 3px;
                display: inline-block;
                margin-right: 4px;
                border: 1px solid #ccc;
              "></span>
            <span>Downloading</span>
          </span>
                    <span style="display: flex; align-items: center">
            <span style="width: 16px; height: 16px; background: #4caf50; border-radius: 3px; display: inline-block; margin-right: 4px"></span>
            <span>Download</span>
          </span>
                    <span style="display: flex; align-items: center">
            <span style="width: 16px; height: 16px; background: #ff000099; border-radius: 3px; display: inline-block; margin-right: 4px"></span>
            <span>Removed</span>
          </span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="d-flex flex-row">
        <app-images-panel
                (paintCoverageEvent)="this.paintWKT($event.wkt, 'EPSG:4326', $event.id)"
                (closeEvent)="this.closeImagesPanel()"
                [images]="this.viewerService.loadedImages$ | async"
                *ngIf="showImagesPanel"></app-images-panel>
        <app-aoi-panel
                [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
                *ngIf="showAois"
                (closeEvent)="this.closeAoiPanel()"
                (fitEvent)="this.fit($event)"
                (paintCoverageEvent)="this.paintWKT($event.wkt, 'EPSG:4326', $event.id)"></app-aoi-panel>
    </div>
</div>
